import { keyInterface, responseInterface } from 'swr';
import { generateCRUD, useHttp } from '@Libs/http';

export interface DiseasePrams {
    limit?: number;
    offset?: number;
    [key: string]: any;
}

const diseaseApi = generateCRUD(
    'diseases',
    (http, path) => ({
        findCountAllAlphabet: async () => {
            const response = await http.get(`${path}/alphabet_count`);
            return response.data;
        },

        findOneDiseaseByAlphabet: async (alphabet: string, prams?: DiseasePrams) => {
            const response = await http.get(`${path}/alphabet/${alphabet}`, {
                params: {
                    ...prams,
                },
            });
            return response.data;
        },
    }),
    { hasPagination: true },
);

export default diseaseApi;

const DISEASE_KEY = 'diseases_key';
export const getDisease = (params: any, key: keyInterface = DISEASE_KEY): responseInterface<any, any> =>
    useHttp(key, async ({ cmsHttp }) => await diseaseApi(cmsHttp).find(params));

const ALPHABET_KEY = 'alphabet_key';
export const getCountAlphabet = (key = ALPHABET_KEY): responseInterface<any, any> => useHttp(key, async ({ cmsHttp }) => await diseaseApi(cmsHttp).findCountAllAlphabet());
